import { type FC } from 'react';
import { ContractItem } from '@components/ContractItem/ContractItem';
import { motion } from 'framer-motion';

import { goodsList } from '@/common/constants';
import { useIntroState } from '@/common/hooks/intro-ref';
import { useHighlightComponentRect } from '@/components/Intro/hooks/highlight-component-rect';
import {
  filterContractListByKind,
  selectSortedByGoodsContracts,
} from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import { ActiveSpecContractList } from '../ActiveSpecContractList/ActiveSpecContractList';
import { ContractItemAnimationWrapper } from '../ContractItemAnimationWrapper/ContractItemAnimationWrapper';
import { ExpiredSpecContractList } from '../ExpiredSpecContractList/ExpiredSpecContractList';

interface ContractListProps {
  isUninitialized: boolean;
  userLevel: number;
}

const ContractList: FC<ContractListProps> = ({ isUninitialized }) => {
  const ref23 = useHighlightComponentRect(23);
  const step22 = useIntroState(22);
  const isFirstVisit = useAppSelector((state) => state.user.isFirstVisit);
  const contractList = useAppSelector((state) =>
    filterContractListByKind(state, 'Default'),
  );
  const sortedContracts = useAppSelector((state) =>
    selectSortedByGoodsContracts(state, 'Default'),
  );

  const list = isFirstVisit ? sortedContracts : contractList;

  return (
    <motion.div
      layout
      className="px-8 md-h:pt-4 pt-6 h-[9.5rem] md-h:h-[9rem] overflow-y-hidden flex gap-8 w-max md-h:mb-3 mb-6"
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
    >
      <ExpiredSpecContractList />
      <ActiveSpecContractList tab="standart" />
      {list?.map((props) => {
        const isContractWithGoods = goodsList.includes(
          Object.keys(props.data)[0],
        );

        return (
          <ContractItemAnimationWrapper
            id={isContractWithGoods ? 'intro-step-23' : undefined}
            ref={isContractWithGoods ? ref23 : undefined}
            isUninitialized={isUninitialized}
            key={props.id}
          >
            <ContractItem
              className={
                isContractWithGoods && step22.showAnimation
                  ? 'relative pointer-events-auto z-[11]'
                  : ''
              }
              isButton={true}
              {...props}
              key={props.id}
              inModal={false}
            />
          </ContractItemAnimationWrapper>
        );
      })}
    </motion.div>
  );
};

export default ContractList;
